import { z } from 'zod'

import { bookingProperties } from './BaseModels'

export const bookingParser = z.object(bookingProperties)

export type Booking = z.infer<typeof bookingParser>
